import React from 'react';

import { TEST_VIEW } from '../../../../../constants/bot';

import { ButtonIcon } from '../../../../../design-system';
import {
    Robot2FillIcon,
    Robot2LineIcon,
    FlashlightFillIcon,
} from '../../../../../design-system/Icons';
import ToolTip from '../../../../../design-system/ToolTip/ToolTip';
import { useResponsiveBreakpoints } from '../../../../../hooks/useResponsiveBreakpoints';

const ViewToggle = ({ view, setView }) => {
    const assistantType = view === TEST_VIEW.assistant ? 'primary' : 'link';
    const apiType = view === TEST_VIEW.api ? 'primary' : 'link';

    const assistantIcon = view === TEST_VIEW.assistant ? Robot2LineIcon : Robot2FillIcon;

    const { isDesktop } = useResponsiveBreakpoints();

    return (
        <div className="flex items-center gap-0.5">
            <ToolTip
                text="Test Assistant"
                position="top-right"
                shift="-2px"
                isShown={!isDesktop && false}
                useInternalHoverStateToShowToolTip={isDesktop}
            >
                <ButtonIcon
                    type={assistantType}
                    size="xs"
                    icon={assistantIcon}
                    onClick={() => setView(TEST_VIEW.assistant)}
                />
            </ToolTip>

            <ToolTip
                text="Test API"
                position="top-right"
                shift="-2px"
                isShown={!isDesktop && false}
                useInternalHoverStateToShowToolTip={isDesktop}
            >
                <ButtonIcon
                    type={apiType}
                    size="xs"
                    icon={FlashlightFillIcon}
                    onClick={() => setView(TEST_VIEW.api)}
                />
            </ToolTip>
        </div>
    );
};

export default ViewToggle;
